"use client";

import { m, MotionConfig } from "framer-motion";
import { twMerge } from "tailwind-merge";
import { usePathname } from "next/navigation";
import { ChevronDown } from "lucide-react";

import GlowEllipse from "@/components/animation";

export default function HeroSection({
  heading,
  subHeading,
  paragraph,
  headingStyles,
  paragraphStyles,
  scrollTarget,
}) {
  const pathname = usePathname();

  const handleScroll = () => {
    const target = document.getElementById(scrollTarget);
    if (target) {
      target.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <>
      <GlowEllipse />

      <MotionConfig reducedMotion="user">
        <div
          key={pathname}
          className="relative flex flex-col justify-center items-center text-center xl:h-screen max-w-[2000px] z-50 mt-16 xl:mt-0 lg:mt-20"
        >
          <m.div
            initial={{ y: -100, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{
              type: "spring",
              mass: 1,
              stiffness: 80,
              damping: 20,
            }}
            viewport={{ once: true }}
            className="will-change-transform transform-gpu"
          >
            <h1
              className={twMerge(
                "font-alexandria font-bold text-[35px] mobile:text-[55px] sm:text-[72px] md:text-[85px] tablet:text-[100px] lg:text-[120px] xl:text-[145px] laptop:text-[180px] 3xl:text-[210px] 4xl:text-[240px] uppercase tracking-[0.1rem] mobile:tracking-[0.4rem] leading-[100%]",
                headingStyles
              )}
            >
              {heading}
            </h1>

            <p className="font-manrope font-medium text-[8px] md:text-[14px] lg:text-[16px] xl:text-[20px] 3xl:text-2xl text-paragraph tracking-[0.74em]">
              {subHeading}
            </p>
          </m.div>

          <m.div
            initial={{ y: 100, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{
              type: "spring",
              mass: 1,
              stiffness: 80,
              damping: 20,
            }}
            viewport={{ once: true }}
            className="flex flex-col items-center will-change-transform transform-gpu"
          >
            <p
              className={twMerge(
                "font-alexandria font-medium text-[14px] sm:text-[18px] lg:text-[22px] xl:text-[30px] 4xl:text-[35px] text-paragraph xl:leading-[130%] xl:max-w-[1090px] 3xl:max-w-[1400px] mt-4 xl:mt-[54px]",
                paragraphStyles
              )}
            >
              {paragraph}
            </p>
            {scrollTarget && (
              <button
                onClick={handleScroll}
                className="font-medium font-manrope text-sm lg:text-[18px] flex flex-col items-center hover:text-[#FF1CF7] cursor-pointer mt-24"
              >
                Scroll Down <ChevronDown />
              </button>
            )}
          </m.div>

        </div>
      </MotionConfig>
    </>
  );
}
